import { styled } from "@pigment-css/react";

export const SECTION_GAP = 16;
export const HEADER_GAP = 6;

// Restores the horizontal padding a bleed Card removes (see Card).
export const Section = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[SECTION_GAP],
  padding: `0 ${theme.fieldSalesTwo.spacing[20]}`,
}));

export const Header = styled("header")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[HEADER_GAP],
}));

export const MetaLabel = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size["15"],
  fontWeight: theme.fieldSalesTwo.font.weight["520"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["148"],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.subtle,
  color: theme.fieldSalesTwo.colors.neutral[800],
}));

// h2/24
export const Headline = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size["24"],
  fontWeight: theme.fieldSalesTwo.font.weight["500"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["130"],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.hairline,
  color: theme.fieldSalesTwo.colors.neutral[850],
  // Group names like "Trockensaucen/Fertigmischungen/Suppen" are single unbreakable
  // tokens (slashes are no CSS break opportunity) and would overflow the card.
  overflowWrap: "anywhere",
}));

export const CardHeadline = styled(Headline)(({ theme }) => ({
  fontSize: theme.fieldSalesTwo.font.size["17"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["140"],
  color: theme.fieldSalesTwo.colors.neutral[900],
}));

// h3/22 — compact card title, e.g. on the revenue-detail (analysis) views
export const HeadlineSmall = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size["22"],
  fontWeight: theme.fieldSalesTwo.font.weight["520"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["136"],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.tighter,
  color: theme.fieldSalesTwo.colors.neutral[900],
  overflowWrap: "anywhere",
}));

// display/40 — large KPI values like the revenue total
export const KpiHeadline = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.familySecondary,
  fontSize: theme.fieldSalesTwo.font.size["40"],
  fontWeight: theme.fieldSalesTwo.font.weight["500"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["125"],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.display,
  color: theme.fieldSalesTwo.colors.neutral[850],
  // Values like the tenant-wide Gesamtumsatz ("234.567.890,12 €") have no break
  // opportunity and would overflow the card at this size on narrow viewports.
  overflowWrap: "anywhere",
}));

export const KpiValue = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size["20"],
  fontWeight: theme.fieldSalesTwo.font.weight["500"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["148"],
  color: theme.fieldSalesTwo.colors.neutral[900],
}));

export const Footer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.fieldSalesTwo.spacing[16],
}));

export const FooterCol = styled("div")(({ theme }) => ({
  flex: "1 0 0",
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[6],
  minWidth: 0,
}));

export const FooterValue = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size["15"],
  fontWeight: theme.fieldSalesTwo.font.weight["500"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["148"],
  color: theme.fieldSalesTwo.colors.neutral[900],
  overflowWrap: "anywhere",
}));

export const SubLabel = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size["13"],
  fontWeight: theme.fieldSalesTwo.font.weight["500"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["148"],
  color: theme.fieldSalesTwo.colors.neutral[700],
}));
